//@flow
import React from 'react';

import css from './navbar.css';
import {
  Container
} from 'flux/utils';
import Store from './store';
import invariant from 'invariant';
import MainMenu from './mainmenu';
import SubMenuDesktop from './submenu-desktop';
import SubMenuMobile from './submenu-mobile';
import MediaQuery from 'react-responsive';

// require('matchmedia-polyfill');

class NavBar extends React.Component < * , > {

  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return {
      store: Store.getState(),
    };
  }



  render() {
    let store = this.state ? this.state.store : null;
    invariant(store, "No store!");


    return <div className={css.container}>
      <MainMenu items={this.props.mainMenuItems} store={store} {...this.props}/>
      <MediaQuery minWidth={767}>
      {(matches) => {
      if (matches) {
        return <SubMenuDesktop items={this.props.subMenuItems} store={store}/>;
      } else {
        return <SubMenuMobile items={{...this.props.mainMenuItems,...this.props.subMenuItems}} store={store}/>;
      }
      }}
    </MediaQuery>
  </div>
  }
}
export default Container.create(NavBar);